import { Nullable } from '@clearverify/types';

import { AddressInfoFragment } from 'src/api';
import { DroppedFile } from 'src/types/file';

export enum CompanyInformationFormPeoAdminFields {
  displayName = 'displayName',
  industry = 'industry',
  corporateStructure = 'corporateStructure',
  taxYearEndDate = 'taxYearEndDate',
  numberOfEmployees = 'numberOfEmployees',
  contactPhoneNumber = 'contactPhoneNumber',
  contactEmail = 'contactEmail',
  headquarters = 'headquarters',
  defaultDisclaimer = 'defaultDisclaimer',
  fein = 'fein',
  logoFile = 'logoFile',
}

export type CompanyInformationFormPeoAdminValues = {
  [CompanyInformationFormPeoAdminFields.displayName]: Nullable<string>;
  [CompanyInformationFormPeoAdminFields.industry]: Nullable<string>;
  [CompanyInformationFormPeoAdminFields.contactEmail]: Nullable<string>;
  [CompanyInformationFormPeoAdminFields.contactPhoneNumber]: Nullable<string>;
  [CompanyInformationFormPeoAdminFields.taxYearEndDate]: Nullable<string>;
  [CompanyInformationFormPeoAdminFields.corporateStructure]: Nullable<string>;
  [CompanyInformationFormPeoAdminFields.numberOfEmployees]: Nullable<number>;
  [CompanyInformationFormPeoAdminFields.fein]: Nullable<string>;
  [CompanyInformationFormPeoAdminFields.defaultDisclaimer]: Nullable<string>;
  [CompanyInformationFormPeoAdminFields.logoFile]: Nullable<DroppedFile>;
  [CompanyInformationFormPeoAdminFields.headquarters]: Nullable<Omit<AddressInfoFragment, 'id'>>;
};
